import React from 'react';
import ButtonComponent from './ButtonComponent';
import { BUTTON_CANCEL, BUTTON_SUBMIT, BUTTON_WARNING } from '../assets/constants/Constants';

const BasicModal = ({
  open,
  onClose,
  title,
  children,
  onCancel,
  onSubmit,
  submitDisabled = false,
  cancelText =BUTTON_CANCEL ,
  submitText =BUTTON_SUBMIT,
}) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{title}</h3>
        </div>

        <div className="modal-body">{children}</div>

        <div className="modal-footer">
          <ButtonComponent
            title={cancelText}
            type={BUTTON_WARNING}
            className="btn btn-cancel"
            handleClick={onCancel || onClose}
          />
          <ButtonComponent
            title={submitText}
            className="btn btn-submit"
            handleClick={onSubmit}
            disabled={submitDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default BasicModal;
